var fonts = {
  body: 'Open Sans, system-ui, sans-serif',
  heading: 'Open Sans, system-ui, sans-serif'
};
var fontSizes = ['11px', '12px', '14px', '16px', '20px', '28px', '40px'];
var lineHeights = ['16px', '16px', '20px', '24px', '28px', '40px', '56px'];
var medium = 600;
var light = 300; // alias

var regular = 400; // styled-system's `fontWeight` function can hook into the `fontWeights` object

var fontWeights = {
  medium: medium,
  light: light,
  // alias
  regular: regular
};
var letterSpacings = {
  normal: 'normal',
  caps: '0.6px'
};
var typography = {
  fonts: fonts,
  fontSizes: fontSizes,
  lineHeights: lineHeights,
  fontWeights: fontWeights,
  letterSpacings: letterSpacings
};
export default typography;
export { typography };